"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfoMapper = void 0;
const models_1 = require("../models");
const makeUserTitle = (user) => {
    const name = user ? `${user.firstName} ${user.lastName}` : "";
    const designation = user && user.designation ? ` - ${user.designation.shortHand}` : "";
    return name + designation;
};
const userInfoMapper = (user) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (user._id && { id: user._id })), (user.firstName && { name: `${user.firstName} ${user.lastName}` })), (user.firstName && { firstName: user.firstName })), (user.lastName && { lastName: user.lastName })), { title: makeUserTitle(user) }), (user.image && { image: user.image })), (user.organizationId && { organizationId: user.organizationId })), (user.designation && {
        designation: {
            id: user.designation.id,
            name: user.designation.name,
            shortHand: user.designation.shortHand,
        },
    })), (user.department && {
        department: {
            id: user.department.id,
            name: user.department.name,
            shortHand: user.department.shortHand,
        },
    })), (user.status && {
        status: models_1.USER_STATUS[user.status],
    })), (user.type && { type: models_1.USER_TYPE[user.type] })), (user.about && { about: user.about })), { groupType: models_1.GROUP_TYPE.PRIVATE, chatType: models_1.CHAT_TYPE.PRIVATE }), (user.phoneNo && { phoneNo: user.phoneNo })), (user.countryCode && { countryCode: user.countryCode })), (user.availableStatus && {
        availableStatus: user.availableStatus,
    })), (user.createdBy && { createdBy: user.createdBy })), (user.email && { email: user.email })), (user.isOnline !== undefined && { isOnline: user.isOnline })), (user.knowMeMore && { knowMeMore: user.knowMeMore })), (user.lastActive && { lastActive: user.lastActive })), (user.onDNDMode !== undefined && { onDNDMode: user.onDNDMode })), (user.organization && { organization: user.organization })), (user.updatedAt && { updatedAt: user.updatedAt }));
};
exports.userInfoMapper = userInfoMapper;
